export const ServiceLogTestIds = {
  // ServiceLog.js
  LOG_BUTTON: 'service-log.log-button',

  // InteractionDrawerContent.js
  INTERACTION_DATE: 'interaction-form.interaction-date',
  TYPE_SELECT: 'interaction-form.type-select',
  SUBJECT_INPUT: 'interaction-form.subject-input',
  DESCRIPTION_INPUT: 'interaction-form.description-input',
  CONTACT_SELECT: 'interaction-form.contact-select',
  CONTACT_NAME_INPUT: 'interaction-form.contact-name-input',
  CONTACT_EMAIL_INPUT: 'interaction-form.contact-email-input',
  RESOLUTION_INPUT: 'interaction-form.resolution-input',
  FOLLOW_UP_DATE: 'interaction-form.follow-up-date',
  FOLLOW_UP_CHECKBOX: 'interaction-form.follow-up-checkbox',
};
